import { getDatabricksDashboardLink } from '~/lib/databricks/getDatabricksDashboardLink';
import type { DashboardEmbedConfig } from '~/lib/databricks/types';

export async function getMarketingCampaignsDashboardLink(): Promise<
  DashboardEmbedConfig | undefined
> {
  const apiUrl =
    '/api/mixone/api/v1/dashboards/digital_campaign_planner/link?dashboard_type=general_marketing';
  const config = await getDatabricksDashboardLink(apiUrl);

  return config;
}
